// Services
import puppySellService from "@/app/services/main/puppy-sell/puppy-sell-service.js";

// Constants
import { STATUS_CODES } from "@/app/constants/status-constants";
import { STATES } from "@/app/constants/state-constants.js";

// Mixins
import { addressMixins } from "@/app/mixins/utils/address-mixins"
import { dateMixins } from '@/app/mixins/utils/date-mixins';

// Third Party libraries
const VueGallerySlideshow = () =>
	import(/* webpackPrefetch: true, webpackChunkName: "vue-gallery-slideshow"*/ "vue-gallery-slideshow")

export default {
    name: "BreederBioDetailsPage",
    components: {
		VueGallerySlideshow,
	},
    directive: {},
    filters: {},
    mixins: [addressMixins, dateMixins],
    props: {},
    data() {
        return {
            // Breeder Details
            breederDetails: {
                breederSysId: "",
                breederId: "",
                state: "",
                emailAddress: "",
                mobileNumber: "",
                status: "DEACTIVATED",
                companyName: "",
            },
            // Breeder Bio
            breederBio: {
                ourPlace: "",
                puppyReady: "",
                healthWell: "",
                termCon: "",
            },

            // Puppy Details
            puppyDetails: {
                id: "",
                breedName: "",
                gender: "",
                images: [],
                body: "",
                puppyReferenceNumber: "",
                puppyName: "",
            },

            // Puppy Images
            puppyPrimaryImg: "",
            puppyImages: [],
            otherImages: [],
            index: null,

            isVerified: true,
            isAPILoading: false,
            isReadMore: [false, false, false, false],
        };
    },
    computed: {},
    created() {
        this.getBreederDetails(this.$route.query.id);
    },
    mounted() {
        window.scrollTo(0, 0);
    },
    methods: {
        hasProfileImage(img) {
            let profileImg = require("@/assets/images/_shared/default-user-pic.png");

            if (img) {
                profileImg = img;
            }

            return profileImg;
        },

        // Gallery
		onClicked(v) {
			this.index = v
		},

        navigateToDetails() {
            this.$router.go(-1);
        },
        
        async getBreederDetails(puppySellId) {
            if (!puppySellId) return;

            try {
                this.isAPILoading = true;

                const response = await puppySellService.getPuppySellDetailsById(
                    {
                        f_puppyToSellId: puppySellId,
                    }
                );

                if (response.status === STATUS_CODES.SUCCESS) {
                    if (response.data.breederBio) {
                        const { ourPlace, puppyReady, healthWell, termCon } =
                            response.data.breederBio;

                        this.breederBio = {
                            ourPlace,
                            puppyReady,
                            healthWell,
                            termCon,
                        };
                    }

                    if (response.data.puppyDetails) {
                        const { id, breedName, puppyName, puppyReferenceNumber, body, images, gender, birthdate } = response.data.puppyDetails

                        this.puppyDetails = {
                            id,
                            breedName,
                            puppyName,
                            puppyReferenceNumber,
                            body,
                            images,
                            gender,
                            birthdate
                        }

                        this.puppyPrimaryImg = images.filter((img) => img.primary === true)
                        this.puppyImages = images.map((img) => { return img.imageUrl })
                        this.otherImages = images
                            .filter((img) => img.primary === false)
                            .map((img) => { return img.imageUrl })
                    }

                    this.breederDetails = {
                        ...response.data.breeder,
                        state: STATES[response.data.breeder.state],
                    };

                    this.isVerified = response.data.breeder.verified
                        ? true
                        : false;

                    this.isAPILoading = false;
                } else {
                    this.isAPILoading = false;
                }
            } catch (err) {
                // Catch any error
                this.isAPILoading = false;
            }
        },
        toggleReadMore(index) {
            this.isReadMore = [...this.isReadMore];
            this.isReadMore[index] = !this.isReadMore[index];
        },
    },
};
